// extracted by mini-css-extract-plugin
export var clearIcon = "fG_mn";
export var dropdown = "fG_kb";
export var hasClearIcon = "fG_mm";
export var open = "fG_kK";
export var small = "fG_b4";